import { Injectable } from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { _colonne } from './nica-grid.component';

@Injectable({
  providedIn: 'root'
})




export class NicaGridService {
defaultColonne:_colonne
constructor(public http: HttpClient) { }
public getProgramm(routine){
  if(routine=='testCer'){
    return "gdfdfgdfgdfd\
    dfgdfgd"
  }
}


public getTemplate(template):_colonne{
  if(template=='Provincie')
  return {
    isForm:true,
    isDataGrid:true,
    dataField:'siglaProvincia',
    caption:'Provincia',
    colVisible:true,
    editorType:'dxSelectBox',
    defaultValue:'NA',
    relatedField:[
      {          
        api:'CurrentData',        
        dataField:[{fieldDatasource:'siglaProvincia',fieldDestination:'bookedOnArrivalDay'}], 
      },
    ],
    //editorOptions:{disabled: false,inputAttr:{NicaGridComponent:this}},
    type:'campo',
    dxolookup:{         
      api:"Provincia",
      displayExpr:'descrizione',
      valueExpr:'siglaProvincia',
      filter:"?$filter=idRegione eq '{{regione}}'",
    }
  }
}

public CreateDsCustom(myApiLook,filter,key){
  console.log("Ecco in CreateDsCustom",myApiLook)
  myApiLook=environment.BASE_API_URL+myApiLook;
  return new CustomStore({
    errorHandler: function (error) {},
    onLoading: function (values) {},
    onInserted: function (values, key) {},
    key:'id',
    loadMode: "raw",
    load: (loadOptions: any) => {
      let params: HttpParams = new HttpParams();
      [
        'skip',
        'take',
        'requireTotalCount',
        'requireGroupCount',
        'sort',
        'filter',
        '$filter',
        'totalSummary',
        'group',
        'groupSummary',
        'TipoOperazione'
      ].forEach((i) => {
        if (i in loadOptions && this.isNotEmpty(loadOptions[i])) {
          let cVal = JSON.stringify(loadOptions[i]); cVal = cVal.replace(/"/g, "");
          params = params.set(i, cVal);
        }
      });
      return this.http.get(myApiLook + filter, { params }).toPromise().then(res => {
        if (res['items']) {
          res = res['items']
        } else {
          res = res
        }
        return res
      })

    },
    

  })

}

  

  public CreateDs(myApi,filter,key){
    myApi=environment.BASE_API_URL+myApi
    return new CustomStore({
      errorHandler: function (error) {},
      onLoading: function (values) {},
      onLoaded(result) {        
      },
      onInserted: function (values, key) {},
      key: 'id',      
      load: (loadOptions: any) => {
        let params: HttpParams = new HttpParams();
        [
          'skip',
          'take',
          'requireTotalCount',
          'requireGroupCount',
          'sort',
          'filter',
          'totalSummary',
          'group',
          'groupSummary',
          'TipoOperazione'
        ].forEach((i) => {
          if (i in loadOptions && this.isNotEmpty(loadOptions[i])) {
            let cVal = JSON.stringify(loadOptions[i]); cVal = cVal.replace(/"/g, "");
            params = params.set(i, cVal);
          }
        });
        return this.http.get(myApi + filter, { params }).toPromise().then(res => {
          if (res['items']) {
            res = res['items']
          } else {
            res = res
          }
          return res
        })

      },
      insert: (values) => {
       // values[this.asDetail.chiave] = this.detailValue;
        //////console.log(values)
        return this.http.post(myApi, values)
          .toPromise()
          .then(res => {//////console.log(res), //////console.log(values)
          })
          .catch();
      },
      update: (key, values) => {
        return this.http.put(myApi + '/' + encodeURIComponent(key), values)
          .toPromise()
          .then(res => {////console.log("Ritorno da Update ",res);
            ////console.log("Ritorno da Update ",values)
            //////console.log(values)
          });
      }
      ,
      remove: (key) => {
        return this.http.delete(myApi + '/' + encodeURIComponent(key))
          .toPromise().then();
      },
      byKey: key => {
        //const person = persone.find(p => p.id === key);
        //return person ? Promise.resolve(person) : Promise.reject('Record not found');
        return this.http.get(myApi + '/'+key)
                    .toPromise();
      }
    })
  }
private isNotEmpty(value: any): boolean {
    return value !== undefined && value !== null && value !== '';
  }
}
